import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import { AppointmentServiceInternal } from "../../services/appointment.service";
import cofirmappointmentlogo from "../../assets/images/ConfmAppointment-logo.png";
import { Box, Button, Stack, Typography } from '@mui/material';
import FullPageLoader from "../Shared/FullPageLoader";
import { toast } from "react-toastify";
import { BUTTONS } from '../../constants';
import userStore from '../../store/store';


interface ConfirmApplicationProps {
  changeStep: (data: any) => void;
  formData: any;
  primaryProviderMessage: string;
  convertedTime: string;
  isReschedule: boolean;
  currentAppointment: any;
  updateFormData: (data: any) => void;
}

const ConfirmAppointmentForm: React.FC<ConfirmApplicationProps> = (props) => {
  const { formData } = props;
  const user: any = userStore();
  const [isLoading, setIsLoading] = useState(false);

  const formatDate = (inputDate: string | number | Date) => {
    const dateObject = new Date(inputDate);
    return dateObject.toLocaleDateString('en-US', { weekday: 'long', month: 'numeric', day: 'numeric', year: 'numeric' });
  };

  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    setIsLoading(true);
    event.preventDefault();
    const postData = {
      appointmentid: props?.currentAppointment?.appointmentid ?? 0,
      appointmenttypeid: Number(formData.appointmenttypeid),
      providerId: Number(formData.providerId),
      appointmentdatetime: formData.appointmentDate.toISOString(),
      appointmentDate: formData.appointmentDate.toLocaleString('en-US', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }),
      appointmentTime: formData.appointmentTime,
      inmatename: props?.currentAppointment?.inmatename ?? formData.inmatename,
      inmatedob: props?.currentAppointment?.inmatedob ?? new Date(formData.inmatedob),
      heldforanothercounty: formData.heldforanothercounty,
      countyid: Number(formData.countyid),
      countyname: formData.countyname,
      admincountyid: Number(formData.admincountyid),
      additionalinfo: props?.currentAppointment?.additionalinfo ?? formData.additionalinfo,
      medications: props?.currentAppointment?.medications ?? formData.medications,
      providerName: formData.providername,
      ZipCode: props?.currentAppointment?.zipCode ?? formData.ZipCode,
      athenaAppointmentId: formData.athenaAppointmentId,
      athenaPatientId: props?.currentAppointment?.athenaPatientId ?? 0,
      hasAthenaAssessment: props?.currentAppointment?.hasAthenaAssessment ?? false,
      inmateFirstName: props?.currentAppointment?.inmateFirstName ?? formData.inmateFirstName,
      inmateLastName: props?.currentAppointment?.inmateLastName ?? formData.inmateLastName,
      facilityName: formData.facilityName,
      correctionalFacilityId: formData.correctionalFacilityId
    };

    try {    
      const response = props?.isReschedule ?
      await AppointmentServiceInternal.rescheduleappointment(props?.currentAppointment.appointmentid, postData) :
      await AppointmentServiceInternal.saveappointment(postData);
      if (response?.data.isSuccess) {
        const userRoleId = user.getUser().id_role;
        window.location.href = userRoleId === 2 ? "/facility-dashboard" : "/itp-dashboard";
      }
      else {
        setIsLoading(false);
        toast.error(response?.data.message);
      }
    }
    catch (error: any) {
      setIsLoading(false);
      toast.error("Error confirming appointment: " + error.response.data.message);
    }
  };

  const handlePrevious = () => {
    props.updateFormData({
      ...props.formData,
      appointmentTime: "",
      appointmentDate: "",
      appointmentDateTime: "",
      athenaAppointmentId: 0
    });
    props.changeStep(-1);
  }

  return (
    <>
      {isLoading && <FullPageLoader />}
      <form onSubmit={onSubmit} className="add-patient-form">
        <div className="d-flex justify-content-center">
          <Card
            style={{
              width: '100%',
              maxHeight: 'calc(100vh - 113px)',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Card.Body style={{ flex:1, overflowY: 'auto' }}>
              <Card.Title>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box>
                      <img alt="" src={cofirmappointmentlogo} style={{ height: 32, width: 32 }} />
                    </Box>
                    <Typography variant="h6" component="h2" sx={{ fontWeight: "bold" }}>
                      Confirm { !props?.isReschedule ? "Appointment" : "Reschedule" }
                    </Typography>
                  </Stack>
                </Box>
              </Card.Title>
              <Box display="flex" gap={1} flexDirection="column" justifyContent="space-between" alignItems="center" width="100%">
                { user.getFacilities().length > 1 && (
                  <Stack direction="row" spacing={1} width="100%" justifyContent="space-between" paddingX="30%">
                    <Typography variant="body1">
                      <strong>Facility:</strong>
                    </Typography>
                    <Typography variant="body1">
                      {formData.facilityName}
                    </Typography>
                  </Stack>
                )}
                <Stack direction="row" spacing={1} width="100%" justifyContent="space-between" paddingX="30%">
                  <Typography variant="body1">
                    <strong>Appointment type:</strong>
                  </Typography>
                  <Typography variant="body1">
                    {formData.appointmenttypename}
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} width="100%" justifyContent="space-between" paddingX="30%">
                  <Typography variant="body1">
                    <strong>Provider:</strong>
                  </Typography>
                  <Typography variant="body1">
                    {formData.providername}
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} width="100%" justifyContent="space-between" alignItems="flex-start" paddingX="30%">
                  <Typography variant="body1">
                    <strong>Date:</strong>
                  </Typography>
                  <Typography variant="body1">
                    {formatDate(formData.appointmentDate)} @ {props.convertedTime}
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} width="100%" justifyContent="space-between" alignItems="flex-start" paddingX="30%">
                  <Typography variant="body1">
                    <strong>Inmate Name:</strong>
                  </Typography>
                  <Typography variant="body1">
                    {formData.inmateFirstName + " " + formData.inmateLastName}
                  </Typography>
                </Stack>
                {formData.heldforanothercounty && (
                  <Stack direction="row" spacing={1} width="100%" justifyContent="space-between" alignItems="flex-start" paddingX="30%">
                    <>
                      <Typography variant="body1">
                        <strong>Held For:</strong>
                      </Typography>
                      <Typography variant="body1">
                        {formData.countyname}
                      </Typography>
                    </>
                  </Stack>
                )}
                <Stack direction="row" spacing={1} width="100%" justifyContent="space-between" alignItems="flex-start" paddingX="30%">
                  {formData.medications !== "" ? (
                    <>
                      <Typography variant="body1">
                        <strong>Medication List:</strong>
                      </Typography>
                      <Typography variant="body1">
                        {formData.medications}
                      </Typography>
                    </>
                  ) : (
                    <Typography variant="body1">
                      <strong>No medications listed.</strong>
                    </Typography>
                  )}
                </Stack>
                <Stack direction="row" spacing={1} width="100%" justifyContent="space-between" alignItems="flex-start" paddingX="30%">
                  {formData.additionalinfo !== "" ? (
                    <>
                      <Typography variant="body1">
                        <strong>Additional Info:</strong>
                      </Typography>
                      <Typography variant="body1">
                        {formData.additionalinfo}
                      </Typography>
                    </>
                  ) : (
                    <Typography variant="body1">
                      <strong>No additional information specified.</strong>
                    </Typography>
                  )}
                </Stack>
              </Box>
            </Card.Body>
            <Card.Footer className="text-center d-flex justify-content-center gap-3 flex-wrap">
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={6}
                flexWrap="wrap"
              >
                <Button
                  type='button'
                  variant="outlined"
                  sx={{ minWidth: 120 }}
                  onClick={() => {
                    handlePrevious();
                  }}
                >
                  {BUTTONS.PREVIOUS}
                </Button>
                  <Button 
                    type='submit' 
                    variant="contained"
                    sx={{ minWidth: 120 }}
                  >
                    Confirm
                  </Button>
              </Box>
            </Card.Footer>
          </Card >
        </div >
      </form >
    </>
  );
};

export default ConfirmAppointmentForm;
